export default function getButtonColors(status) {
    let color = 'badge-light';
    if (status=='waiting') color = 'badge-warning';
    else if (status == 'declined') color = 'badge-danger';
    else if (status == 'approved') color = 'badge-success';
    else if (status == 'uploaded') color = 'badge-warning';

    return color;
}
